import { createContext, useContext } from "react";

export interface FilterBarContextValue {
  pendingValues: Record<string, unknown>;
  setPendingValue: (source: string, value: unknown) => void;
  /** FilterFields register their display label so applied-filter chips can name themselves. */
  registerLabel: (source: string, label: string) => void;
}

export const FilterBarContext = createContext<FilterBarContextValue | null>(
  null,
);

export const useFilterBarContext = (): FilterBarContextValue => {
  const ctx = useContext(FilterBarContext);
  if (!ctx) {
    throw new Error("FilterField must be rendered inside <ListActionsBar>");
  }
  return ctx;
};
